import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";
import { Quote } from "lucide-react";

export default function Identity() {
    const { t } = useLang();
    return (
        <section
            id="identity"
            className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)]"
            data-testid="sau-identity"
        >
            <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-10 text-center">
                <SectionHeading align="center" eyebrow={t.identity.eyebrow} title={t.identity.title} />
                <p className="sau-reveal mt-6 sm:mt-8 text-[15px] sm:text-lg md:text-xl text-[color:var(--sau-text-2)] leading-relaxed">
                    {t.identity.body}
                </p>

                <figure className="sau-reveal mt-10 sm:mt-12 mx-auto max-w-3xl">
                    <div className="relative sau-gradient-border p-[1px] rounded-3xl">
                        <blockquote className="rounded-3xl bg-[#0A1726] px-6 sm:px-8 md:px-12 py-9 sm:py-10 md:py-14">
                            <Quote className="w-6 h-6 mx-auto text-[color:var(--sau-accent)] opacity-70" />
                            <p
                                className="mt-5 sm:mt-6 text-xl sm:text-2xl md:text-3xl font-medium sau-glow-text"
                                style={{ letterSpacing: "-0.01em", lineHeight: 1.3 }}
                            >
                                “{t.identity.quote}”
                            </p>
                            <figcaption className="mt-5 sm:mt-6 text-[10px] uppercase tracking-[0.28em] sm:tracking-[0.32em] text-[color:var(--sau-muted)]">
                                {t.meta.brandFull}
                            </figcaption>
                        </blockquote>
                    </div>
                </figure>
            </div>
        </section>
    );
}
